export default "__VITE_ASSET__HzYoh1Z4__"